let currentId = 1;
let isScrolling = false;
var body = $('body');

let area1Enter = false;
let area2Enter = false;
let area3Enter = false;
let area4Enter = false;
let area5Enter = false;

let draggable_height = $('#rd-swiper-line').height();

$(function(){
    // 如果顯示視窗有尺寸變化 直接重整頁面
    let old_window_width = $(window).width();
    window.addEventListener('resize', function(){
        let new_window_width = $(window).width();
        if(new_window_width != old_window_width){
            location.reload();
        }
    });

    // 監聽 unload 事件
    window.addEventListener('unload', function (event) {
        window.scrollTo(0, 0);
    });

    $('#rd-line').css('height', '20%');
    $('#rd-replacement-1').css('height', $('#rd-bnbox-1').height() + 'px');
    $('#rd-replacement-2').css('height', $('#rd-bnbox-2').height() + 'px');
    $('#rd-replacement-3').css('height', $('#rd-bnbox-3').height() + 'px');
    $('#rd-replacement-4').css('height', $('#rd-bnbox-4').height() + 'px');

    $('.rd-prev-btn').on('click', function(){
        if (isScrolling || currentId == 1) {
            return;
        }

        isScrolling = true;
        currentId --;

        if($(window).width() > 991){
            $("html, body").animate({
                scrollTop: $("#rd-replacement-" + currentId).offset().top
            }, 1000, function(){
                isScrolling = false;
            });
        }else{
            $("html, body").animate({
                scrollTop: $("#rd-bnbox-" + currentId).offset().top
            }, 1000, function(){
                isScrolling = false;
            });
        }

    });

    $('.rd-next-btn').on('click', function(){
        if (isScrolling || currentId == 5) {
            return;
        }

        let areaEnter = false;

        isScrolling = true;
        currentId ++;

        switch(currentId){
            case 1:
                areaEnter = area1Enter;
                break;
            case 2:
                areaEnter = area2Enter;
                break;
            case 3:
                areaEnter = area3Enter;
                break;
            case 4:
                areaEnter = area4Enter;
                break;
            case 5:
                areaEnter = area5Enter;
                break;
        }

        let time = 0;
        if(areaEnter == false){
            time = 1000;
        }

        if($(window).width() > 991){
            $("html, body").animate({
                scrollTop: $("#rd-bnbox-" + currentId).offset().top
            }, 1000, function() {
                if(time){
                    // 滾動後解鎖滾輪
                    setTimeout(function() {
                        isScrolling = false;
                    }, time);
                }else{
                    isScrolling = false;
                }
            });
        }else{
            $("html, body").animate({
                scrollTop: $("#rd-bnbox-" + currentId).offset().top
            }, 1000, function() {
                if(time){
                    // 滾動後解鎖滾輪
                    setTimeout(function() {
                        isScrolling = false;
                    }, time);
                }else{
                    isScrolling = false;
                }
            });
        }
    });

    scrollAnimate();
    if($(window).width() > 991){
        $(window).scroll(function() {
            scrollIndexAnimate();
        });
        scrollIndexAnimate();
    }

    let link = "";
    $('.rd-mb-bn-logo').on('click', function(){
        if($('.rd-mb-bn-logo-box').hasClass('type1')){
            link = 'product/list/formalwear';
        }else if($('.rd-mb-bn-logo-box').hasClass('type2')){
            link = 'product/list/casualwear-isp';
        }else if($('.rd-mb-bn-logo-box').hasClass('type3')){
            link = 'product/list/workwear';
        }else if($('.rd-mb-bn-logo-box').hasClass('type4')){
            link = 'product/list/medical';
        }else if($('.rd-mb-bn-logo-box').hasClass('type5')){
            link = 'infinity-shirt-project';
        }else{
            return;
        }

        location.href = link;
    });

    // var myFullpage = new fullpage('#rd-fullpage', {
    //     licenseKey: '64CMK-AL9IK-BW8KK-YEJTJ-WKEHL',
    //     parallax: true,
    //     parallaxKey: 'NjljMnQxYm1sbWIzSnRMbU52YlM1MGR3PT1LQV8zMXJjR0Z5WVd4c1lYZz04OWg=',
    //     parallaxOptions: {
    //         type: 'cover',
    //         percentage: 62,
    //         property: 'translate'
    //     },
    //     scrollingSpeed: 1000,
    //     autoScrolling: true,
    //     scrollBar: false,
    //     scrollOverflow: false,
    //     afterLoad: function(origin, destination, direction, trigger){
    //         let draggable_height = $('#rd-swiper-line').height();
    //         currentId = destination.index + 1;
    //         if(destination.index >= 0 && destination.index <= 4){
    //             let move_distance = (destination.index / 5) * draggable_height;
    //             $('#rd-line').css('transform', 'translate(-50%, 0%) translate3d(-0.415px, '+ move_distance +'px, 0px)');
    //             $('#draggable-number').html(currentId);
    //             $('#rd-bnbox-' + currentId).addClass('do');
    //         }
    //         switch(currentId){
    //             case 1:
    //                 animation1.play();
    //                 animation2.play();
    //                 animation3.play();
    //                 animation4.play();
    //                 if($(window).width() < 992){
    //                     $('.rd-mb-bn-logo').show();
    //                     $('.rd-mb-bn-logo-box').addClass('type1');
    //                     $('.rd-mb-bn-logo-box').removeClass('type2');
    //                     $('.rd-mb-bn-logo-box').removeClass('type3');
    //                     $('.rd-mb-bn-logo-box').removeClass('type4');
    //                     $('.rd-mb-bn-logo-href').attr('href', 'product/list/formalwear');
    //                 }
    //                 break;
    //             case 2:
    //                 animation5.play();
    //                 animation6.play();
    //                 animation7.play();
    //                 animation8.play();
    //                 if($(window).width() < 992){
    //                     $('.rd-mb-bn-logo').show();
    //                     $('.rd-mb-bn-logo-box').addClass('type2');
    //                     $('.rd-mb-bn-logo-box').removeClass('type1');
    //                     $('.rd-mb-bn-logo-box').removeClass('type3');
    //                     $('.rd-mb-bn-logo-box').removeClass('type4');
    //                     $('.rd-mb-bn-logo-href').attr('href', 'product/list/casualwear-isp');
    //                 }
    //                 break;
    //             case 3:
    //                 animation9.play();
    //                 animation10.play();
    //                 animation11.play();
    //                 animation12.play();
    //                 if($(window).width() < 992){
    //                     $('.rd-mb-bn-logo').hide();
    //                 }
    //                 break;
    //             case 4:
    //                 animation13.play();
    //                 animation14.play();
    //                 animation15.play();
    //                 animation16.play();
    //                 if($(window).width() < 992){
    //                     $('.rd-mb-bn-logo').show();
    //                     $('.rd-mb-bn-logo-box').addClass('type3');
    //                     $('.rd-mb-bn-logo-box').removeClass('type1');
    //                     $('.rd-mb-bn-logo-box').removeClass('type2');
    //                     $('.rd-mb-bn-logo-box').removeClass('type4');
    //                     $('.rd-mb-bn-logo-href').attr('href', 'product/list/workwear');
    //                 }
    //                 break;
    //             case 5:
    //                 animation17.play();
    //                 animation18.play();
    //                 animation19.play();
    //                 animation20.play();
    //                 if($(window).width() < 992){
    //                     $('.rd-mb-bn-logo').show();
    //                     $('.rd-mb-bn-logo-box').addClass('type4');
    //                     $('.rd-mb-bn-logo-box').removeClass('type1');
    //                     $('.rd-mb-bn-logo-box').removeClass('type2');
    //                     $('.rd-mb-bn-logo-box').removeClass('type3');
    //                     $('.rd-mb-bn-logo-href').attr('href', 'product/list/medical');
    //                 }
    //                 break;
    //             default:
    //                 if($(window).width() < 992){
    //                     $('.rd-mb-bn-logo').hide();
    //                 }
    //                 break;
    //         }

    //         fullpage_api.setMouseWheelScrolling(false);
    //         fullpage_api.setAllowScrolling(false);
    //         setTimeout(() => {
    //             fullpage_api.setMouseWheelScrolling(true);
    //             fullpage_api.setAllowScrolling(true);
    //         }, 2500);
    //         isAnimating = true;
    //         setTimeout(() => {
    //             isAnimating = false;
    //         }, 3500);
    //     },
    //     onLeave: function(origin, destination, direction, trigger){
    //         if(destination.index >= 0 && destination.index <= 4){
    //             currentId = destination.index + 1;
    //             $('#rd-bnbox-' + currentId).removeClass('do');

    //             switch(currentId){
    //                 case 1:
    //                     animation1.goToAndStop(0);
    //                     animation2.goToAndStop(0);
    //                     animation3.goToAndStop(0);
    //                     animation4.goToAndStop(0);
    //                     break;
    //                 case 2:
    //                     animation5.goToAndStop(0);
    //                     animation6.goToAndStop(0);
    //                     animation7.goToAndStop(0);
    //                     animation8.goToAndStop(0);
    //                     break;
    //                 case 3:
    //                     animation9.goToAndStop(0);
    //                     animation10.goToAndStop(0);
    //                     animation11.goToAndStop(0);
    //                     animation12.goToAndStop(0);
    //                     break;
    //                 case 4:
    //                     animation13.goToAndStop(0);
    //                     animation14.goToAndStop(0);
    //                     animation15.goToAndStop(0);
    //                     animation16.goToAndStop(0);
    //                     break;
    //                 case 5:
    //                     animation17.goToAndStop(0);
    //                     animation18.goToAndStop(0);
    //                     animation19.goToAndStop(0);
    //                     animation20.goToAndStop(0);
    //                     break;
    //             }
    //         }
    //     },
    // });
});

function scrollIndexAnimate(){
    var scrollTop = $(window).scrollTop();

    var element1Top = $('#rd-bnbox-1').offset().top;
    var element2Top = $('#rd-bnbox-2').offset().top;
    var element3Top = $('#rd-bnbox-3').offset().top;
    var element4Top = $('#rd-bnbox-4').offset().top;
    var element5Top = $('#rd-bnbox-5').offset().top;

    $('.rd-mb-bn-logo-box').removeClass('type1');
    $('.rd-mb-bn-logo-box').removeClass('type2');
    $('.rd-mb-bn-logo-box').removeClass('type3');
    $('.rd-mb-bn-logo-box').removeClass('type4');
    $('.rd-mb-bn-logo-box').removeClass('type5');

    if (scrollTop >= element5Top) {
        $('#draggable-number').html(5);
        let move_distance = (4 / 5) * draggable_height;
        $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');

        $('.rd-mb-bn-logo-box').show();
        $('.rd-mb-bn-logo-box').addClass('type4');
    }else if (scrollTop >= element4Top) {
        $('#draggable-number').html(4);
        let move_distance = (3 / 5) * draggable_height;
        $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');

        $('.rd-mb-bn-logo-box').show();
        $('.rd-mb-bn-logo-box').addClass('type3');
    }else if (scrollTop >= element3Top) {
        $('#draggable-number').html(3);
        let move_distance = (2 / 5) * draggable_height;
        $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');

        $('.rd-mb-bn-logo-box').hide();
    }else if (scrollTop >= element2Top) {
        $('#draggable-number').html(2);
        let move_distance = (1 / 5) * draggable_height;
        $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');

        $('.rd-mb-bn-logo-box').show();
        $('.rd-mb-bn-logo-box').addClass('type2');
    }else{
        $('#draggable-number').html(1);
        let move_distance = (0 / 5) * draggable_height;
        $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');

        $('.rd-mb-bn-logo-box').show();
        $('.rd-mb-bn-logo-box').addClass('type1');
    }
}

function scrollAnimate() {
    ScrollTrigger.create({

    });
    createIndexScrollTrigger('#rd-bnbox-1', 'do', 1, 'type1', area1Enter);
    createIndexScrollTrigger('#rd-bnbox-2', 'do', 2, 'type2', area2Enter);
    createIndexScrollTrigger('#rd-bnbox-3', 'do', 3, 'type5', area3Enter);
    createIndexScrollTrigger('#rd-bnbox-4', 'do', 4, 'type3', area4Enter);
    createIndexScrollTrigger('#rd-bnbox-5', 'do', 5, 'type4', area5Enter);

    createFromToScrollTrigger('#rd-bnbox-2', '#rd-bnbox-1');
    createFromToScrollTrigger('#rd-bnbox-3', '#rd-bnbox-2');
    createFromToScrollTrigger('#rd-bnbox-4', '#rd-bnbox-3');
    createFromToScrollTrigger('#rd-bnbox-5', '#rd-bnbox-4');
}

function createFromToScrollTrigger(trigger, sceneTrigger){
    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function(){
            let scene = gsap.timeline();
            ScrollTrigger.create({
                animation: scene,
                trigger: trigger,
                start: "top bottom",
                scrub: 1,
                markers:false,
            });
            scene.fromTo(sceneTrigger, { y: 0}, {y: -100}, 0)
        },
    });
}

function createIndexScrollTrigger(trigger, move, index, mbBnBox, firstTime){
    let top = "top top"
    if(index === 1){
        top = "top-=1px top"
    }
    ScrollTrigger.matchMedia({
        "(min-width: 992px)": function(){
            ScrollTrigger.create({
                trigger: trigger,
                start: top,
                end: "top+=2px top",
                scrub: 1,
                markers:false,
                onEnter: function () {

                    switch(index){
                        case 1:
                            setTimeout(function () {
                                animation1.play();
                                animation2.play();
                                animation3.play();
                                animation4.play();
                            }, 500)

                            break;
                        case 2:
                            animation5.play();
                            animation6.play();
                            animation7.play();
                            animation8.play();
                            break;
                        case 3:
                            animation9.play();
                            animation10.play();
                            animation11.play();
                            animation12.play();
                            break;
                        case 4:
                            animation13.play();
                            animation14.play();
                            animation15.play();
                            animation16.play();
                            break;
                        case 5:
                            animation17.play();
                            animation18.play();
                            animation19.play();
                            animation20.play();
                            break;
                        default:
                            break;
                    }

                    currentId = index;
                    setTimeout(function () {
                        $(trigger).addClass(move);
                    }, 500)


                    if(firstTime == false){
                        $("html, body").scrollTop($(trigger).offset().top);
                        firstTime = true;

                        var userAgent = navigator.userAgent.toLowerCase();

                        if(userAgent.indexOf('safari') !== -1 && !(userAgent.indexOf('chrome') !== -1)){
                            document.body.style.overflow = 'hidden';
                            setTimeout(() => {
                                document.body.style.overflow = 'auto';
                            }, 2000);
                        }else{
                            lockScroll(body);
                            setTimeout(() => {
                                unlockScroll(body, true)
                            }, 2000);
                        }

                    }

                    showReplacement(index);
                    changeProductUrl(index, trigger)
                },
                onEnterBack: function () {
                    hideReplacement(index);

                    currentId = index;
                    $(trigger).addClass(move);
                    changeProductUrl(index, trigger)
                },
                onLeaveBack: function(){
                    hideReplacement(index);

                    currentId = index;
                    $(trigger).addClass(move);
                    changeProductUrl(index, trigger)
                }
            });
        },
        "(max-width: 991px)": function() {
            ScrollTrigger.create({
                trigger: trigger,
                start: top,
                end: "top+=10% top",
                scrub: 1,
                markers:false,
                onEnter: function () {

                    switch(index){
                        case 1:
                            setTimeout(function () {
                                animation1.play();
                                animation2.play();
                                animation3.play();
                                animation4.play();
                            }, 500)
                            break;
                        case 2:
                            animation5.play();
                            animation6.play();
                            animation7.play();
                            animation8.play();
                            break;
                        case 3:
                            animation9.play();
                            animation10.play();
                            animation11.play();
                            animation12.play();
                            break;
                        case 4:
                            animation13.play();
                            animation14.play();
                            animation15.play();
                            animation16.play();
                            break;
                        case 5:
                            animation17.play();
                            animation18.play();
                            animation19.play();
                            animation20.play();
                            break;
                        default:
                            break;
                    }
                    currentId = index;
                    if(!$(trigger).hasClass(move)){
                        setTimeout(function () {
                            $(trigger).addClass(move);
                        }, 500)
                    }
                    let move_distance = ((currentId - 1) / 5) * draggable_height;
                    $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');
                    $('#draggable-number').html(currentId);

                    $('.rd-mb-bn-logo-box').removeClass('type1');
                    $('.rd-mb-bn-logo-box').removeClass('type2');
                    $('.rd-mb-bn-logo-box').removeClass('type3');
                    $('.rd-mb-bn-logo-box').removeClass('type4');
                    $('.rd-mb-bn-logo-box').removeClass('type5');

                    if(mbBnBox){
                        $('.rd-mb-bn-logo-box').show();
                        $('.rd-mb-bn-logo-box').addClass(mbBnBox);
                    }else{
                        $('.rd-mb-bn-logo-box').hide();
                    }

                    if(firstTime == false){
                        $("html, body").scrollTop($(trigger).offset().top);
                        firstTime = true;
                        document.body.style.overflow = 'hidden';
                        setTimeout(() => {
                            document.body.style.overflow = 'auto';
                        }, 3000);
                    }

                    changeProductUrl(index, trigger)
                },
                onEnterBack: function () {
                    currentId = index;
                    let move_distance = ((currentId - 1) / 5) * draggable_height;
                    $('#rd-line').css('transform', 'translate(0%, 0%) translate3d(0px, '+ move_distance +'px, 0px)');
                    $('#draggable-number').html(currentId);

                    $('.rd-mb-bn-logo-box').removeClass('type1');
                    $('.rd-mb-bn-logo-box').removeClass('type2');
                    $('.rd-mb-bn-logo-box').removeClass('type3');
                    $('.rd-mb-bn-logo-box').removeClass('type4');
                    $('.rd-mb-bn-logo-box').removeClass('type5');

                    if(mbBnBox){
                        $('.rd-mb-bn-logo-box').show();
                        $('.rd-mb-bn-logo-box').addClass(mbBnBox);
                    }else{
                        $('.rd-mb-bn-logo-box').hide();
                    }
                    changeProductUrl(index, trigger)
                },
                onLeave: function(){
                    if(index == 5){
                        $('.rd-mb-bn-logo-box').hide();
                    }
                    changeProductUrl(index, trigger)
                }
            });
        },
    });

}

function changeProductUrl(id, target){

    $('.rd-product-link').attr('href',$(target).data('url'))
}

function showReplacement(id){

    if(id != 5){
        $('#rd-replacement-' + id).show();
        $('#rd-bnbox-' + id).css('position', 'fixed');
        $('#rd-bnbox-' + id).css('top', 0);
        $('#rd-bnbox-' + id).css('left', 0);
    }
}

function hideReplacement(id){
    if(id != 1){
        $('#rd-replacement-' + id).hide();
        $('#rd-bnbox-' + id).css('position', '');
        $('#rd-bnbox-' + id).css('top', "");
        $('#rd-bnbox-' + id).css('left', "");
    }
}
